import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/icons/AlertCircleIcon.tsx
var i = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M21 12C21 7.02948 16.9705 3 12 3C7.02948 3 3 7.02948 3 12C3 16.9705 7.02948 21 12 21C16.9705 21 21 16.9705 21 12ZM12.0098 15C12.5621 15 13.0098 15.4477 13.0098 16C13.0098 16.5523 12.5621 17 12.0098 17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H12.0098ZM11 12V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92492 23 1 18.0751 1 12C1 5.92492 5.92492 1 12 1C18.0751 1 23 5.92492 23 12Z",
		fill: "currentColor"
	})
}), a = {
	12: {
		Artwork: i,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M8.00635 9.9165C8.42045 9.9165 8.75617 10.2524 8.75635 10.6665C8.75635 11.0807 8.42056 11.4165 8.00635 11.4165H8.00049C7.58628 11.4165 7.25049 11.0807 7.25049 10.6665C7.25066 10.2524 7.58638 9.9165 8.00049 9.9165H8.00635Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.00049 4.5835C8.41455 4.58367 8.75049 4.91939 8.75049 5.3335V8.00049C8.75031 8.41444 8.41444 8.75031 8.00049 8.75049C7.58638 8.75049 7.25066 8.41455 7.25049 8.00049V5.3335C7.25049 4.91928 7.58628 4.5835 8.00049 4.5835Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.00049 0.583496C12.0964 0.583672 15.4165 3.90452 15.4165 8.00049C15.4163 12.0963 12.0963 15.4163 8.00049 15.4165C3.90452 15.4165 0.583672 12.0964 0.583496 8.00049C0.583496 3.90441 3.90441 0.583496 8.00049 0.583496ZM8.00049 2.0835C4.73284 2.0835 2.0835 4.73284 2.0835 8.00049C2.08367 11.268 4.73294 13.9165 8.00049 13.9165C11.2679 13.9163 13.9163 11.2679 13.9165 8.00049C13.9165 4.73294 11.268 2.08367 8.00049 2.0835Z",
					fill: "currentColor"
				})
			]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: i,
		width: 20,
		height: 20
	},
	24: {
		Artwork: i,
		width: 24,
		height: 24
	}
}, o = ({ size: t = 16, tone: r = "default", className: i, ...o }) => /* @__PURE__ */ n(e, {
	source: a[t],
	monochrome: !0,
	className: ["pf-icon-" + r, i].filter(Boolean).join(" "),
	...o
});
//#endregion
export { o as AlertCircleIcon };
